import { render, staticRenderFns } from "./check-in-registered-patient.vue?vue&type=template&id=d9b136ce&scoped=true&"
import script from "./check-in-registered-patient.vue?vue&type=script&lang=js&"
export * from "./check-in-registered-patient.vue?vue&type=script&lang=js&"
import style0 from "./check-in-registered-patient.vue?vue&type=style&index=0&id=d9b136ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b136ce",
  null
  
)

export default component.exports